import { render, staticRenderFns } from "./GraphsCard.vue?vue&type=template&id=081c72f8&scoped=true"
import script from "./GraphsCard.vue?vue&type=script&lang=js"
export * from "./GraphsCard.vue?vue&type=script&lang=js"
import style0 from "./ServerManage.scss?vue&type=style&index=0&id=081c72f8&prod&lang=scss&scoped=true&external"
import style1 from "./GraphsCard.vue?vue&type=style&index=1&id=081c72f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081c72f8",
  null
  
)

export default component.exports